import React, { useState, useEffect } from 'react';
import "../styles/AssPopup.css";
import "../styles/assumptionPopup.css";
import { X, Plus } from "lucide-react";
import axiosInstance from '../axiosInstance';
import { toast } from "react-toastify";

function Popup2({ closePopup, editData, triggerReload }) {
  const [title, setTitle] = useState('');
  const [effectiveFrom, setEffectiveFrom] = useState('');
  const [effectiveTo, setEffectiveTo] = useState('');
  const [rows, setRows] = useState([{ termsCloneId: null, label: '', description: '' }]);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (editData?.id) {
      const fetchTermDetails = async () => {
        try {
           const response = await axiosInstance.get(
            `/costsolution/termsandcondition/get/${editData.id}`
          );
          const term = response.data.term;
          setTitle(term.title);
          setEffectiveFrom(term.effective_from_date);
          setEffectiveTo(term.effective_to_date);
          const termClones = term.termClone || term.terms_clones || [];
          setRows(termClones.map(item => ({
            termsCloneId: item.termsCloneId,
            label: item.label,
            description: item.description
          })) || [{ termsCloneId: null, label: '', description: '' }]);

          setIsEditing(true);

        } catch (error) {
          console.error("Error fetching term details:", error);
          toast.error("Failed to load term details");
        }
      };

      fetchTermDetails();
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const termData = {
      title,
      effectiveFromDate: effectiveFrom,
      effectiveToDate: effectiveTo,
      termsMandatories: rows
      .filter(row => row.label.trim() || row.description.trim())
      .map(row => ({
        id: row.id || "",
        label: row.label,
        description: row.description
      }))
  };
    try {
      const url = isEditing
        ? `/costsolution/termsandcondition/${editData.id}`
        : "/costsolution/termsandcondition";

      const method = isEditing ? "put" : "post";

      const response = await axiosInstance({
        method,
        url,
        data: termData
      });

      if (response.status === 200 || response.status === 201) {
        toast.success(isEditing ? "Term updated successfully!" : "Term created successfully!");
        triggerReload(); 
        closePopup();
      } else {
        toast.error("Error: " + (response.data.message || "Failed to process request"));
      }
    } catch (error) {
      console.error("Error saving term:", error);
      toast.error("Failed to save term: " + (error.response?.data?.message || error.message));
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setTitle('');
    setEffectiveFrom('');
    setEffectiveTo('');
    setRows([{ termsCloneId: null, label: '', description: '' }]);
  };

  const addRow = () => {
    setRows([...rows, { 
      termsCloneId: null, 
      label: '', 
      description: '' 
    }]);
  };

  const removeRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);
  };

  return (
      <div className="modal-overlay">
        <div className="modal-container">
          <div className="modal-header">
            <h2>{isEditing ? 'Edit Term' : 'Create Term'}</h2>
            <button className="close-button" onClick={closePopup}>X</button>
          </div>
          <div className="modal-contents">
            <div className="form-group">
              <label className="assumption-title">Title</label>
              <input
                type=""
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter title"
                required
              />
            </div>

            <div className="form-group">
              <label className="assumption-effective-from">Effective From</label>
              <div className="date-input-container">
                <input
                  type="date"
                  value={effectiveFrom}
                  onChange={(e) => setEffectiveFrom(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="assumption-effective-to">Effective To</label>
              <div className="date-input-container">
                <input
                  type="date"
                  value={effectiveTo}
                  onChange={(e) => setEffectiveTo(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="assumption-table-container">
              <div className="table-wrapper">
                <table className="assumption-table">
                  <thead className="assumption-thead">
                    <tr className="assumption-tr">
                      <th className="assumption-th label-column">LABEL</th>
                      <th className="assumption-th description-column">DESCRIPTION</th>
                      <th className="assumption-th action-column"></th>
                    </tr>
                  </thead>

                  <tbody className="assumption-tbody">
                    {rows.map((row, index) => (
                      <tr className="assumption-tr" key={index}>
                        <td className="assumption-td label-column">
                          <input
                            type=""
                            name="label"
                            value={row.label}
                            onChange={(e) => handleChange(index, e)}
                            placeholder="Enter label"
                            className="table-input"
                          />
                        </td>
                        <td className="assumption-td description-cell">
                          <input
                            type=""
                            name="description"
                            value={row.description}
                            onChange={(e) => handleChange(index, e)}
                            placeholder="Enter description"
                            className="table-input"
                          />
                          <button className="remove-row-button" onClick={() => removeRow(index)}>
                            <X size={16} style={{ textAlign: "right" }} />
                          </button>
                        </td>
                        <td></td>
                      </tr>
                    ))}
                  </tbody>

                  <tfoot>
                    <tr>
                      <td className="assumption-td label-column"></td>
                      <td></td>
                      <td style={{ textAlign: "right" }}>
                        <button className="add-button" onClick={addRow}>
                          <Plus size={18} />
                        </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <div className="modal-footer">
              <button className="clear-button" onClick={handleClear}>Clear</button>
              <button 
                className="submit-button" 
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>

  );
}

export default Popup2;